import { MarketingConfig } from "types"

export const marketingConfig: MarketingConfig = {
  mainNav: [
    {
      title: "Products",
      href: "/pricing",
    },
    // {
    //   title: "Guides",
    //   href: "/docs",
    // },
  ],
}
